import { render, staticRenderFns } from "./OrderListImport.vue?vue&type=template&id=5bce4d04&scoped=true&"
import script from "./OrderListImport.vue?vue&type=script&lang=js&"
export * from "./OrderListImport.vue?vue&type=script&lang=js&"
import style0 from "./OrderListImport.vue?vue&type=style&index=0&id=5bce4d04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce4d04",
  null
  
)

export default component.exports